import graphql from './routers/graphql';
import rest from './routers/rest';

export default [...rest, ...graphql];
